module.exports = __webpack_public_path__ + "static/media/enable-disable.567427a6.svg";